import { Search } from "@mui/icons-material";
import { Grid, TextField, Tooltip } from "@mui/material";
import { css, StyleSheet } from "aphrodite";

type FilterCursosProps = {
  searchCourses: () => void;
  searchCodCurso: string;
  setSearchCodCurso: React.Dispatch<React.SetStateAction<string>>;
};

export const FilterCursos = ({
  searchCourses,
  searchCodCurso,
  setSearchCodCurso,
}: FilterCursosProps) => {
  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <TextField
          label="Buscar pelo código ou descrição"
          size="small"
          fullWidth
          value={searchCodCurso}
          onChange={(e) => setSearchCodCurso(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              searchCourses();
            }
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 1, lg: 0.5 }}>
        <Tooltip title={"Buscar"}>
          <button className={css(styles.btn)} onClick={searchCourses}>
            <Search />
          </button>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

const styles = StyleSheet.create({
  pageTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#4b4b4b",
  },
  input: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    backgroundColor: "#004AAD",
    color: "#fff",
    fontFamily: "Poppins",
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#004AAD",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    // marginTop: "1.95rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
    },
    ":active": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    backgroundColor: "#B3B3B3",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#B3B3B3",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    marginTop: "1.95rem",
  },
  erro: {
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
  topBtn: {
    backgroundColor: "#004AAD",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#004AAD",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#186ad6ff",
      backgroundColor: "transparent",
      borderColor: "#186ad6ff",
    },
    ":active": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
      opacity: 0.6,
    },
  },
});
